import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../../constants/sm-constants';

@Component({
  selector: 'sm-send-payment-link',
  templateUrl: './send-payment-link.component.html',
  styleUrls: ['./send-payment-link.component.scss']
})
export class SendPaymentLinkComponent implements OnInit {
  msg:any
  copied:boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any,) { }

  ngOnInit(): void {
    console.log(this.parentData.data);
    
    this.msg = this.parentData.data
   
  }

  copyInputMessage(inputElement:any){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.copied=true
  }
}
